import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import { Card } from '../../../components'
import { format, THEMES, ContactSource } from '../../../utils'

/**
 * Get breakdown count
 * @param id
 * @param data
 * @returns {*|string}
 */
const getCount = (id, data) => {
  const set = (data || []).find((item) => item && item._id === id)
  return (set && set.count) ? format(set.count) : '-'
}

/**
 * Breakdown Component
 */
const Breakdown = (props) => {
  const { isLoading, data } = props
  const source = data.source || []
  const status = data.status || []

  return (
    <Card
      isLoading={isLoading}
      theme={THEMES.DARK_SLATE}
      title='Contacts Breakdown'>

      <Grid container spacing={3}>
        <Grid item xs={3} className='card_section'>
          <h2 className='card_section-subtitle'>SSOT</h2>
          <div className='card_section-detail'>{getCount(ContactSource.SSOT, source)}</div>
        </Grid>
        <Grid item xs={6} className='card_section'>
          <h2 className='card_section-subtitle'>Custom</h2>
          <div className='card_section-detail'>{getCount(ContactSource.Q4DESKTOP, source)}</div>
        </Grid>

        <Grid item xs={3} className='card_section'>
          <h2 className='card_section-subtitle'>Live</h2>
          <div className='card_section-detail'>{getCount('live', status)}</div>
        </Grid>
        <Grid item xs={3} className='card_section'>
          <h2 className='card_section-subtitle'>Unknown</h2>
          <div className='card_section-detail'>{getCount('unknown', status)}</div>
        </Grid>
        <Grid item xs={3} className='card_section'>
          <h2 className='card_section-subtitle'>DNQ</h2>
          <div className='card_section-detail'>{getCount('dnq', status)}</div>
        </Grid>
        <Grid item xs={3} className='card_section'>
          <h2 className='card_section-subtitle'>Deceased</h2>
          <div className='card_section-detail'>{getCount('deceased', status)}</div>
        </Grid>
        <Grid item xs={3} className='card_section'>
          <h2 className='card_section-subtitle'>GDPR</h2>
          <div className='card_section-detail'>{getCount('gdpr', status)}</div>
        </Grid>
        <Grid item xs={3} className='card_section'>
          <h2 className='card_section-subtitle'>Retired</h2>
          <div className='card_section-detail'>{getCount('retired', status)}</div>
        </Grid>
        <Grid item xs={3} className='card_section'>
          <h2 className='card_section-subtitle'>On Leave</h2>
          <div className='card_section-detail'>{getCount('onleave', status)}</div>
        </Grid>
        <Grid item xs={3} className='card_section'>
          <h2 className='card_section-subtitle'>None</h2>
          <div className='card_section-detail'>{getCount(null, status)}</div>
        </Grid>
      </Grid>
    </Card>
  )
}

Breakdown.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.object
}

Breakdown.defaultProps = {
  isLoading: false,
  data: {}
}

export default Breakdown
